import script from "./SulMthodsEN.vue?vue&type=script&setup=true&name=SulMethods&lang=js"
export * from "./SulMthodsEN.vue?vue&type=script&setup=true&name=SulMethods&lang=js"

import "./SulMthodsEN.vue?vue&type=style&index=0&id=4a1d8fea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a1d8fea"]])

export default __exports__